import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, ICreateComboGroup } from 'types';

export type TCreateComboGroupVisibleForm = 'mainForm' | 'translations';
export type TTypeOfCreateComboGroupModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateComboGroupState {
	visibleForm: TCreateComboGroupVisibleForm;
	fetchedCustomers: IItemForGetShortInfo[];
	selectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	selectedRestaurants: string[];
	fetchedDishes: IItemForGetShortInfo[];
	selectedDishes: string[];
	name: string;
	fetchedComboItems: IItemForGetShortInfo[];
	selectedComboItems: string[];
	upperLimit: string;
	lowerLimit: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
	dataForSubmit: ICreateComboGroup | null;
	typeOfModalWindow: TTypeOfCreateComboGroupModalWindow;
}

export const createComboGroupInitialState: ICreateComboGroupState = {
	visibleForm: 'mainForm',
	fetchedCustomers: [],
	selectedCustomer: null,
	fetchedRestaurants: [],
	selectedRestaurants: [],
	fetchedDishes: [],
	selectedDishes: [],
	name: '',
	fetchedComboItems: [],
	selectedComboItems: [],
	upperLimit: '',
	lowerLimit: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateComboGroupContext extends ICreateComboGroupState {
	changeVisibleForm(value: TCreateComboGroupVisibleForm): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setRestaurants(value: string[]): void;
	setFetchedDishes(value: IItemForGetShortInfo[]): void;
	setDishes(value: string[]): void;
	changeName(value: string): void;
	setFetchedComboItems(value: IItemForGetShortInfo[]): void;
	setComboItems(value: string[]): void;
	updateComboItems(value: IItemForGetShortInfo[]): void;
	changeUpperLimit(value: string): void;
	changeLowerLimit(value: string): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(value: ICreateComboGroup | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateComboGroupModalWindow): void;
	resetFields(): void;
}

export const CreateComboGroupContext = createContext<ICreateComboGroupContext>({
	changeVisibleForm: () => undefined,
	setFetchedCustomers: () => undefined,
	setCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setRestaurants: () => undefined,
	setFetchedDishes: () => undefined,
	setDishes: () => undefined,
	changeName: () => undefined,
	setFetchedComboItems: () => undefined,
	setComboItems: () => undefined,
	updateComboItems: () => undefined,
	changeUpperLimit: () => undefined,
	changeLowerLimit: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createComboGroupInitialState,
});
